import { useCallback } from "react";
import { Checkbox, Tooltip } from "@narmi/design_system";

import { modules } from "byzantine";
import { useLocalization } from "@fluent/react";
import styles from "./DeliveryChannels.module.scss";
import { useCurrentUser } from "../../../../contexts/CurrentUserContext";

interface DeliveryChannelsProps {
  alertKey: API.AlertKey;
}

const DeliveryChannels = ({ alertKey }: DeliveryChannelsProps) => {
  const { l10n } = useLocalization();
  const { form } = modules.alerts.useUserAlertsForm(alertKey);
  const { currentUser } = useCurrentUser();
  const {
    values: { deliveryChannels },
  } = form;

  const isSmsDisabled = !currentUser?.phone?.number;

  const hasEmail = deliveryChannels.includes("email");
  const hasSMS = deliveryChannels.includes("sms");
  
  const handleChannelChange = useCallback(
    (channel: API.DeliveryChannel, newHas: boolean) => {
      let newChannels: API.DeliveryChannel[];
      if (newHas) {
        if (!deliveryChannels.includes(channel)) {
          newChannels = [...deliveryChannels, channel];
        } else {
          newChannels = deliveryChannels;
        }
      } else if (deliveryChannels.filter((ch) => ch !== "push").length > 1) {
          newChannels = deliveryChannels.filter((ch) => ch !== channel);
        } else {
          newChannels = deliveryChannels
        }
      form.setFieldValue("deliveryChannels", newChannels);
    },
    [deliveryChannels, form]
  );

  const emailOnChange = useCallback(() => {
    handleChannelChange("email", !hasEmail);
  }, [handleChannelChange, hasEmail]);

  const smsOnChange = useCallback(() => {
    handleChannelChange("sms", !hasSMS);
  }, [handleChannelChange, hasSMS]);

  const smsLabel = l10n.getString(
    "alerts-tooltip-label-sms-disabled",
    {},
    "Update your phone number in profile settings to receive SMS alerts."
  );

  return (
    <div className={styles.container}>
      <Checkbox label="Email" checked={hasEmail} onChange={emailOnChange} />
      {isSmsDisabled ? (
        <Tooltip text={smsLabel}>
          <Checkbox
            label="SMS"
            checked={hasSMS}
            onChange={smsOnChange}
            disabled={isSmsDisabled}
          />
        </Tooltip>
      ) : (
        <Checkbox
          label="SMS"
          checked={hasSMS}
          onChange={smsOnChange}
          disabled={isSmsDisabled}
        />
      )}
    </div>
  );
};

export default DeliveryChannels;
